import { Typography } from '@material-ui/core';

import styles from './FollowUpTypography.module.scss';

const FollowUpTypography = () => <Typography className={styles.label}>Manual</Typography>;

export default FollowUpTypography;
